import { AnalyticsGender, Gender } from '../../../../libs/ba-types/src';
export function getGenderText(value: Gender | AnalyticsGender): string{
	if(value === "M" || value === Gender.Male) return "Male";
	if(value === "F" || value === Gender.Female) return "Female";
	return null;
}
